module.exports = __webpack_public_path__ + "static/media/8.ef7f1c6e.jpg";